// extracted by mini-css-extract-plugin
module.exports = {"result":"_a4759126","icon":"_76890d04","title":"_f26f026f","description":"_d84c15c9"};